<span [ngClass]="{ 'icon-button': true, showBelow: lineBreakAfterIcon, 'hide-control': !visible }">
  <button [disabled]="!enabled" [ngStyle]="colorStyle" (click)="onClick()" class="icon">
    <fa-icon [icon]="icon"></fa-icon>
  </button>
  <button *ngIf="text" [disabled]="!enabled" [ngStyle]="colorStyle" class="plaintext" (click)="onClick()">{{ text }}</button>
</span>
